const dark = {
    title: 'dark',

    colors: {
        primary: '#fff6e4',
        secundary: '#f1d9ab',

        background: '#333',
        text: '#f5f5f5'
    },
};

export default dark